import cx from 'clsx';

import styles from '../../card/Card.module.css';

type CardGridProps = {
  wrap?: boolean;
  justifyCenter?: boolean;
  className?: string;
  children?: React.ReactNode;
};

export function CardGrid({ justifyCenter = false, className, children, wrap = true }: CardGridProps) {
  return (
    <div
      className={cx(styles.CardGrid, className, { 'u-flex-wrap': wrap, [styles['CardGrid--center']]: justifyCenter })}
    >
      {children}
    </div>
  );
}
